<section class="hero is-medium is-fullheight back-section2">
    <div class="hero-body">
        <div class="container has-text-centered">
            <p class="copytitle2">FAQ</p>
            <br />

            <div class="columns is-mobile is-centered has-text-left is-copy">
                <div class="column is-10">
                    <p class="title copy2 is-5 titlefaq">
                        When I mint a NFT from the collection, where does my ETH
                        go?
                    </p>
                    <p class="subtitle copy2">
                        97% of each mint goes to the Ukrainian government, to
                        the official ETH address of the fundraising account of
                        the National Bank of Ukraine. The Ministry of Digital
                        Transformation of Ukraine set up <a
                            class="link"
                            href="https://donate.thedigital.gov.ua/"
                            target="blank">Aid For Ukraine</a
                        >
                        with the support of major crypto exchanges like FTX, Everstake
                        and Kuna, for more info check this article on
                        <a
                            class="link"
                            href="https://cointelegraph.com/news/ukrainian-government-launches-crypto-donation-website-with-ftx-kuna-and-everstake"
                            target="blank">Cointelegraph</a
                        >. On secondary sales on
                        <a
                            class="link"
                            href="https://opensea.io/collection/ibok"
                            target="blank">Opensea</a
                        >, 9% of each sale will be paid as a royalty to Ukraine
                        government address as well. You can inspect the payout
                        function directly in the
                        <a
                            class="link"
                            href="https://etherscan.io/address/0x7e4582773A3bF8EcbdF7FeF10Fff05A3cA83F14D#code"
                            target="blank">contract on Etherscan</a
                        >
                        to verify this.
                    </p>
                    <br />
                    <p class="title copy2 is-5 titlefaq">
                        What does Ukraine do with the ETH?
                    </p>
                    <p class="subtitle copy2">
                        The donated ETH is controlled directly by the Ukrainian
                        government and fhe funds will be used for the support of
                        humanitarian aid programs and the Armed Forces of
                        Ukraine. We are peace loving types, but so are the
                        Ukrainians and is clear that they need all the help they
                        can get to defend themselves, and their citizens, land
                        and freedom. You can read more about what the crypto
                        donations are used for here, see
                        <a
                            class="link"
                            href="https://techcrunch.com/2022/03/02/how-ukraine-is-spending-crypto-donations/"
                            target="blank">this link</a
                        >.
                        <br /><br />
                        Side note, many of the Russian soldiers are basically kids
                        who were conscripted into the army and didn’t even know they
                        were going to war until sent to the front line. We don’t
                        wish harm to them, it’s totally shit that one asshole can
                        rain down destruction on people on both sides.
                    </p>
                    <br />
                    <p class="title copy2 is-5 titlefaq">
                        Why didn’t you focus on humanitarian relief or refugee
                        assistance?
                    </p>
                    <p class="subtitle copy2">
                        That would be totally worthy, and it will be the focus
                        of a follow up project. For now, we wanted the
                        beneficiary to be totally transparent with a public ETH
                        address where we never even touch the funds to avoid any
                        possible perception of a potential rug pull. And, while
                        it’s not really our instinctive position to have
                        anything to do with violence, in this case the moral
                        cause for Ukrainian resistance is clear and the defence
                        is being fought right now. In the case that we sell
                        through (and why wouldn’t we) the follow up will come
                        soon. We have Ukrainian refugees staying both in our
                        buildings at home and work and this is very personal to
                        us.
                    </p>
                    <br />
                    <p class="title copy2 is-5 titlefaq">
                        Should I feel bad about making a profit on this on the
                        secondary market?
                    </p>
                    <p class="subtitle copy2">
                        Actually, the opposite. The higher the floor price and
                        volume on the secondary market on Opensea or any other
                        market, the more funds will be raised for Ukraine. If
                        you 10x your investment, then it’s better for Ukraine.
                        Also, a robust secondary market would help us launch a
                        follow up collection which would raise more funds for
                        Ukrainians affected by the war.
                    </p>
                    <br />
                    <p class="title copy2 is-5 titlefaq">
                        What happens with the rest of the funds?
                    </p>
                    <p class="subtitle copy2">
                        To be transparent, we’re retaining 3% of the mint
                        transaction and 1% of secondary sales. We are using
                        these funds to cover development costs, maintenance
                        costs and to fund development on future fundraising
                        projects so that this is a sustainable first step in
                        helping out. We will also keep 150 NFTS from the
                        collection for giveaways, collabs, and if any are
                        leftover, will be divided amongst the team. These will
                        only have value if the project generates a healthy
                        secondary market and has raised a healthy stack of ETH
                        for Ukraine. Also, we have structured it on top of the
                        10k for fundraising so it doesn’t reduce the donated
                        funds.
                    </p>
                    <br />
                    <p class="title copy2 is-5 titlefaq">
                        How many NFTs are in the collection?
                    </p>
                    <p class="subtitle copy2">
                        There are 10150 NFTS in the original collection, of
                        which 10k will be available to mint. If we sell through
                        the entire collection, we will raise around 200 ETH or
                        around half a million US dollars from the mint at the
                        price at 12.03.21. Plus we are applying a high 10%
                        royalty to generate a continuing donation stream.
                    </p>
                    <br />
                    <p class="title copy2 is-5 titlefaq">
                        Who is behind International Brigade of Kyiv?
                    </p>
                    <p class="subtitle copy2">
                        We are a group of friends and creatives in Berlin and
                        Milan. We prefer to stay undoxxed, because ultimately we
                        don’t really matter, we’re just some assholes making
                        jpegs and donating them while not so far away real
                        heroes are fighting and dying.
                    </p>
                    <br />
                    <p class="title copy2 is-5 titlefaq">
                        Is there a discord? Whitelist?
                    </p>
                    <p class="subtitle copy2">
                        No whitelist. We have an open mint with maximum 50 NFTs
                        per transaction, no max quantity per wallet and no
                        discord planned. We’d rather work on new ways to help
                        rather than talk about helping.
                    </p>
                    <br />
                    <p class="title copy2 is-5 titlefaq">
                        This isn’t for me, how else can I help?
                    </p>
                    <p class="subtitle copy2">
                        <br />
                        CRYPTO DONATIONS:
                        <br />
                        -<a
                            class="link"
                            href="https://donate.thedigital.gov.ua/"
                            target="blank">Aid for Ukraine</a
                        >
                        <br />
                        -<a
                            class="link"
                            href="https://app.endaoment.org/ukraine"
                            target="blank">Endaoment</a
                        >
                        <br />
                        -<a
                            class="link"
                            href="https://www.ukrainedao.love/"
                            target="blank">Ukraine Dao</a
                        >
                        <br /><br />
                        FIAT:<br />
                        -<a
                            class="link"
                            href="https://redcross.org.ua/en/donate/"
                            target="blank">Ukrainian Red Cross</a
                        ><br />
                        -<a
                            class="link"
                            href="https://support.rescue.org/de/Notfall_Ukraine/~spenden"
                            target="blank">International Rescue Committee</a
                        ><br />
                        -<a
                            class="link"
                            href="https://www.dec.org.uk/?gclid=CjwKCAiAg6yRBhBNEiwAeVyL0NOG6J6rixQMKhoBho9Rk7hgNrRsMWsjmr18xntKpYmPhcgF-7InPBoCpAkQAvD_BwE"
                            target="blank">Disaster Emergency Committee</a
                        ><br />
                        -<a
                            class="link"
                            href="https://www.peopleinneed.net/donate/once"
                            target="blank">People in need</a
                        ><br /><br />
                        HOST REFUGEES:
                        <br />
                        -<a
                            class="link"
                            href="https://www.ukrainenow.org/i-can-host"
                            target="blank">Ukraine now</a
                        ><br />
                        -<a
                            class="link"
                            href="https://prykhystok.in.ua/"
                            target="blank">Prykhystok</a
                        >
                    </p>
                    <br />
                </div>
            </div>
        </div>
    </div>
</section>
